export const selectAppConfig = state => state.appConfig;
export const selectIsMockWrapper = state => state.appConfig.isMockWrapper;
export const selectUseMockKambiApi = state => state.appConfig.useMockKambiApi;
export const selectUseProdApis = state => state.appConfig.useProdApis;
